import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login as apiLogin } from '../services/auth';
import { PageHeader } from '../ui/PageHeader';

const DEMO_EMAIL = 'demo@example.com';
const DEMO_PASSWORD = 'password123';

export default function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState(DEMO_EMAIL);
  const [password, setPassword] = useState(DEMO_PASSWORD);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const user = await apiLogin(email, password);
      navigate('/', { replace: true });
    } catch (err: any) {
      setError(err?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="page login-page">
      <PageHeader
        kicker="Welcome Back"
        title="Log In"
        subtitle="Access your SafariCo Hub account"
      />

      <div style={{ maxWidth: 400, margin: '32px auto' }}>
        <form onSubmit={handleSubmit}>
          <label>
            Email
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>

          <label>
            Password
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>

          <button type="submit" disabled={loading} className="btn btnPrimary" style={{ width: '100%' }}>
            {loading ? 'Logging in…' : 'Log In'}
          </button>
          {error && <div className="error" style={{ marginTop: 12 }}>{error}</div>}
        </form>

        <p className="muted" style={{ marginTop: 18, textAlign: 'center' }}>
          Don't have an account? <a href="/register">Create one here</a>
        </p>
      </div>
    </div>
  );
}
